module.exports = __webpack_public_path__ + "static/media/last-purchase.fed73444.svg";